module.exports = __webpack_public_path__ + "static/media/5-_DSC6871.6c61ede3.jpg";